import React from 'react'
import HomeBlog from '../home/HomeBlog'
import { Link } from "react-router-dom";


const Blog = () => {
    return (
        <>

            <section className="breadcrumb-wrapper fix bg-cover" style={{ backgroundImage: 'url(https://res.cloudinary.com/dnquglkeh/image/upload/v1771511829/SBS06987-Pano_2_xhjkdi.jpg)' }}>
                <div className="container">
                    <div className="row">
                        <div className="page-heading">
                            <h2 className="wow fadeInUp" data-wow-delay=".3s">Blog</h2>
                            <ul className="breadcrumb-list wow fadeInUp" data-wow-delay=".5s">
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li><i className="fa-solid fa-chevron-right" /></li>
                                <li>Blog</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="news-section section-padding fix">
                <div className="container">
                    <div className="section-title text-center">
                        <span className="sub-title wow fadeInUp">News &amp; Blogs</span>
                        <h2 className="wow fadeInUp" data-wow-delay=".3s">
                            Latest News Updates
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".3s">
                            <div className="news-card-items">
                                <div className="news-image">
                                    <img src="assets/img/svp/gallery/25.jpg" alt="img" />
                                    <span className="post-box">10th March,2025</span>
                                </div>
                                <div className="news-content">
                                    <h3>
                                        <Link to="/blog">Importance of physical education for young children</Link>
                                    </h3>
                                    <Link to="/blog" className="link-btns">Read Details <i className="fas fa-arrow-right" /></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".5s">
                            <div className="news-card-items">
                                <div className="news-image">
                                    <img src="assets/img/svp/gallery/58.jpg" alt="img" />
                                    <span className="post-box">10th November,2023</span>
                                </div>
                                <div className="news-content">
                                    <ul className="post-meta">
                                    </ul>
                                    <h3>
                                        <Link to="/blog">A Vibrant Diwali Celebration at Saraswati Vidyapeeth HR. SEC. School.</Link>
                                    </h3>
                                    <Link to="/blog" className="link-btns">Read Details <i className="fas fa-arrow-right" /></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".7s">
                            <div className="news-card-items">
                                <div className="news-image">
                                    <img src="assets/img/svp/gallery/6.jpg" alt="img" />
                                    <span className="post-box">01th January,2025</span>
                                </div>
                                <div className="news-content">
                                    <h3>
                                        <Link to="/blog">How can students enhance their communication skills effectively?</Link>
                                    </h3>
                                    <Link to="/blog" className="link-btns">Read Details <i className="fas fa-arrow-right" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Blog